<script setup lang="ts">
    import { ref } from "vue";
    import { Page, GlobalEventCallback } from '@inertiajs/core';
    import { usePage, Link, useForm } from '@inertiajs/vue3';
    import { SharedPageProps } from '@/Types/inertia';
    import { useDatatable } from '@/Composables/Datatable';
    import { toast } from "vue3-toastify";
    import { pageTitle, useTableCard, containerGapForForm } from '@/Composables/PageMeta';
    import { useAuth } from '@/Composables/Auth';
    import DataTable from '@/Components/vuetify/DataTable.vue';
    import helpers from '@/Plugins/helpers';

    // import OldAppLayout from '@/Layouts/OldAppLayout.vue';
    // defineOptions({
    //     layout: OldAppLayout
    // })

    containerGapForForm();
    type PageData = SharedPageProps & {
        data:{
        };
    }
    
    pageTitle.value = "Dashboard";
    const { isSuperadmin, isAdmin } = useAuth();
    const page = usePage<PageData>();
    
</script>

<template>
    <div class="flex-grow-1 d-flex flex-column dashboard">
        <div class="pb-7">
            <v-alert color="danger-lightest fw-medium">
                The data on this page are dummy and for demo purposes only.
            </v-alert>
        </div>
    </div>
</template>
